export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22')
];

export const server_loads = [];

export const dictionary = {
		"/": [3],
		"/(authenticated)/changelog": [4,[2]],
		"/(authenticated)/customers": [5,[2]],
		"/(authenticated)/customers/[id]": [6,[2]],
		"/(authenticated)/customers/[id]/repair-jobs": [7,[2]],
		"/(authenticated)/dashboard": [8,[2]],
		"/(authenticated)/docs": [9,[2]],
		"/(authenticated)/docs/internal-notifications": [10,[2]],
		"/(authenticated)/docs/klaviyo-notifications": [11,[2]],
		"/forgot-password": [21],
		"/(authenticated)/invoices": [12,[2]],
		"/(authenticated)/invoices/[id]": [13,[2]],
		"/(authenticated)/labels": [14,[2]],
		"/(authenticated)/labels/[id]": [15,[2]],
		"/(authenticated)/repair-jobs": [16,[2]],
		"/(authenticated)/repair-jobs/[id]": [17,[2]],
		"/reset-password/[token]": [22],
		"/(authenticated)/settings": [18,[2]],
		"/(authenticated)/settings/line-items": [19,[2]],
		"/(authenticated)/settings/users": [20,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';